import React from "react";
import { useState } from "react";
import { sendPaymentEmail } from "../../../api/caseApi";
import ConfirmationDialog from "../../../common/components/Dialog";

const PaymentEmailDialog = ({
  open,
  onClose,
  caseProgressId,
  onEmailSent,
  onEmailError,
  isSubscription,
}) => {
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    if (loading) return;
    setLoading(true);
    try {
      await sendPaymentEmail(caseProgressId, isSubscription);
      setLoading(false);
      onEmailSent();
      onClose();
    } catch (err) {
      setLoading(false);
      onEmailError(err.response.data.message || err.response.data.title);
      onClose();
    }
  };

  return (
    <ConfirmationDialog
      open={open}
      title={
        isSubscription
          ? "Send recurring payment subscription link to patient's email?"
          : "Send one time payment link to patient's email?"
      }
      handleClose={onClose}
      submit={onSubmit}
      loading={loading}
    />
  );
};

export default PaymentEmailDialog;
